export const appInternalRoutes = {
  HOME_PAGE: "/",
  CONTACT_US_PAGE: "/contact-us",
  ABOUT_US_PAGE: "/about-us",
  OUR_TEAM: "/our-team",
};
